document.getElementById('feedbackForm')?.addEventListener('submit', function (event) {
    event.preventDefault(); // Prevent default form submission

    const form = this;
    let isValid = true;

    // Clear previous error messages
    const errorMessages = form.querySelectorAll('.error-message');
    errorMessages.forEach(error => error.remove());

    // Function to display error messages
    function showError(input, message) {
        const errorMessage = document.createElement('div');
        errorMessage.classList.add('error-message');
        errorMessage.style.color = 'red';
        errorMessage.textContent = message;
        input.parentElement.appendChild(errorMessage); // Append below the input field
    }

    // Validate required rating inputs
    const ratingFields = [
        { name: 'material_quality', message: 'Please rate Material Quality.' },
        { name: 'design', message: 'Please rate Design.' },
        { name: 'longevity', message: 'Please rate Longevity.' },
        { name: 'fit_comfort', message: 'Please rate Fit and Comfort.' },
        { name: 'shopping_experience', message: 'Please rate your Shopping Experience.' }
    ];

    ratingFields.forEach(field => {
        const input = form.querySelector(`input[name="${field.name}"]:checked`);
        if (!input) {
            isValid = false;
            showError(form.querySelector(`input[name="${field.name}"]`), field.message);
        }
    });

    // Validate description accuracy and recommendation inputs
    const requiredYesNoFields = [
        { name: 'description_accuracy', message: 'Please select an option for Product Description Accuracy.' },
        { name: 'recommend', message: 'Please select whether you would recommend A09STORE.' }
    ];

    requiredYesNoFields.forEach(field => {
        const input = form.querySelector(`input[name="${field.name}"]:checked`);
        if (!input) {
            isValid = false;
            showError(form.querySelector(`input[name="${field.name}"]`), field.message);
        }
    });

    // Validate open feedback fields
    const feedbackFields = [
        { name: 'order_id', type: 'textarea', message: 'Please provide Order Id.' },
        { name: 'like_most', type: 'textarea', message: 'Please provide feedback for "What Did You Like Most?".' },
        { name: 'improvement', type: 'textarea', message: 'Please provide feedback for "What Can We Improve?".' },
        { name: 'additional_comments', type: 'textarea' } // Optional field
    ];

    feedbackFields.forEach(field => {
        const input = form.querySelector(`${field.type}[name="${field.name}"]`);
        if (input && !input.value.trim() && field.message) {
            isValid = false;
            showError(input, field.message); // Show error below the textarea
        }
    });

    if (!isValid) {
        return; // Stop if form is invalid
    }

    // Manually collect form data
    const data = new URLSearchParams();

    // Append ratings
    ratingFields.forEach(field => {
        const input = form.querySelector(`input[name="${field.name}"]:checked`);
        if (input) {
            data.append(field.name, input.value);
        }
    });

    // Append Yes/No fields
    requiredYesNoFields.forEach(field => {
        const input = form.querySelector(`input[name="${field.name}"]:checked`);
        if (input) {
            data.append(field.name, input.value);
        }
    });

    // Append textareas
    feedbackFields.forEach(field => {
        const input = form.querySelector(`${field.type}[name="${field.name}"]`);
        if (input) {
            const value = input.value.trim();
            if (field.name === 'additional_comments' && value) {
                data.append(field.name, value); // Send only if it has a value
            } else if (field.message && value) {
                data.append(field.name, value); // Send required fields if they have a value
            }
        }
    });

    // Disable the submit button to prevent multiple submissions
    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
    }

    // Create XMLHttpRequest object
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = true;

    xhr.addEventListener('readystatechange', function () {
        if (this.readyState === 4) {
            console.log('Response:', this.responseText); // Log the raw response for debugging

            try {
                const contentType = xhr.getResponseHeader('Content-Type');
                if (contentType && contentType.includes('application/json')) {
                    const response = JSON.parse(this.responseText);
                    if (response.status === 'success') {
                        showSuccessMessage('Form submitted successfully');
                        form.reset(); // Reset the form on success
                    } else {
                        showError(form, response.message || 'Failed to submit the form. Please try again.');
                    }
                } else {
                    showError(form, 'The server did not return JSON. Please check the server response.');
                }
            } catch (error) {
                console.error('Error parsing response:', error);
                showError(form, 'Invalid server response. Please try again.');
            }

            // Re-enable the submit button after request completion
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = 'Submit';
            }
        }
    });

    // Open the request
    xhr.open('POST', 'https://www.agency09.in/A09storeApi/feedback-form-data.php');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data.toString());
});
function showSuccessMessage(message) {
    const successMessageDiv = document.getElementById('success-message');
    successMessageDiv.textContent = message; // Set the message
    successMessageDiv.style.display = 'block'; // Show the success message

    // Optional: Hide the message after a few seconds
    // setTimeout(() => {
    //     successMessageDiv.style.display = 'none'; // Hide the message after 3 seconds
    // }, 3000);
}
